import { render } from "./QuickpayMarketingPreferences.vue?vue&type=template&id=3d4398f1&scoped=true"
import script from "./QuickpayMarketingPreferences.vue?vue&type=script&lang=js"
export * from "./QuickpayMarketingPreferences.vue?vue&type=script&lang=js"

import "./QuickpayMarketingPreferences.vue?vue&type=style&index=0&id=3d4398f1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4398f1"]])

export default __exports__